import { Helmet } from 'react-helmet-async';

const Layout = ({
	children,
	title = 'Online Dance Training & Lessons',
	description = 'Welcome to The Godfrey Method - On Demand'
}) => {
	return (
		<>
			<Helmet>
				<title>{`${title} | The Godfrey Method On Demand`}</title>
				<meta name="description" content={description} />
				<meta name="viewport" content="width=device-width, initial-scale=1" />
			</Helmet>
			<main>{children}</main>
		</>
	);
};

export default Layout;
